export default [
  {
    id: 'checkout-contractor-data-first-name',
    name: 'firstName',
    label:
      'smb_acquisition_company_info.main_form.fields.first_name.placeholder',
    componentType: 'input',
    columnSize: {
      small: 12,
      medium: 6,
    },
    validations: {
      primitiveType: 'string',
      required: true,
    },
  },
  {
    id: 'checkout-contractor-data-last-name',
    name: 'lastName',
    label:
      'smb_acquisition_company_info.main_form.fields.last_name.placeholder',
    componentType: 'input',
    columnSize: {
      small: 12,
      medium: 6,
    },
    validations: {
      primitiveType: 'string',
      required: true,
    },
  },
  {
    id: 'checkout-contractor-data-email',
    name: 'email',
    label: 'smb_acquisition_company_info.main_form.fields.email.placeholder',
    componentType: 'input',
    columnSize: {
      small: 12,
      medium: 6,
    },
    validations: {
      primitiveType: 'string',
      email: true,
      required: true,
    },
  },
  {
    id: 'checkout-contractor-data-role',
    name: 'role',
    label: 'smb_acquisition_form.fields.role.placeholder',
    componentType: 'select',
    columnSize: {
      small: 12,
      medium: 6,
    },
    items: {
      translation: true,
      defaultElements: {
        insertionMode: 'before', // after, mergeAndSort, clean
        elements: [
          { value: '', name: '' },
          {
            value: 'Trainee_Intern',
            intlKey: 'smb_acquisition_form.fields.role.options.trainee_intern',
            name: 'Trainee Intern',
          },
          {
            value: 'Analyst',
            intlKey: 'smb_acquisition_form.fields.role.options.analyst',
            name: 'Analyst',
          },
          {
            value: 'Board Member',
            intlKey: 'smb_acquisition_form.fields.role.options.board_member',
            name: 'Board Member',
          },
          {
            value: 'CEO',
            intlKey: 'smb_acquisition_form.fields.role.options.ceo',
            name: 'CEO',
          },
          {
            value: 'CFO',
            intlKey: 'smb_acquisition_form.fields.role.options.cfo',
            name: 'CFO',
          },
          {
            value: 'CHRO',
            intlKey: 'smb_acquisition_form.fields.role.options.chro',
            name: 'CHRO',
          },
          {
            value: 'Consultant',
            intlKey: 'smb_acquisition_form.fields.role.options.consultant',
            name: 'Consultant',
          },
          {
            value: 'Coordinator',
            intlKey: 'smb_acquisition_form.fields.role.options.coordinator',
            name: 'Coordinator',
          },
          {
            value: 'Director',
            intlKey: 'smb_acquisition_form.fields.role.options.director',
            name: 'Director',
          },
          {
            value: 'Doctor',
            intlKey: 'smb_acquisition_form.fields.role.options.doctor',
            name: 'Doctor',
          },
          {
            value: 'Executive Assistant',
            intlKey:
              'smb_acquisition_form.fields.role.options.executive_assistant',
            name: 'Executive Assistant',
          },
          {
            value: 'Manager',
            intlKey: 'smb_acquisition_form.fields.role.options.manager',
            name: 'Manager',
          },
          {
            value: 'Self-Employed',
            intlKey: 'smb_acquisition_form.fields.role.options.self_employed',
            name: 'Self-Employed',
          },
          {
            value: 'Specialist',
            intlKey: 'smb_acquisition_form.fields.role.options.specialist',
            name: 'Specialist',
          },
          {
            value: 'Supervisor',
            intlKey: 'smb_acquisition_form.fields.role.options.supervisor',
            name: 'Supervisor',
          },
          {
            value: 'Vice President',
            intlKey: 'smb_acquisition_form.fields.role.options.vice_president',
            name: 'Vice President',
          },
        ],
      },
    },
    validations: {
      primitiveType: 'string',
      required: true,
    },
  },
  {
    id: 'checkout-contractor-data-mobile-phone',
    name: 'mobilePhone',
    label:
      'smb_acquisition_company_info.main_form.fields.cell_phone.placeholder',
    componentType: 'input',
    columnSize: {
      small: 12,
      medium: 6,
    },
    options: {
      mask: '(99) 99999-9999',
    },
    validations: {
      primitiveType: 'string',
      required: true,
      phone: true,
      min: 10,
    },
  },
  {
    id: 'checkout-contractor-data-benefit-manager-document',
    name: 'benefitManagerDocument',
    label: 'smb_acquisition_checkout.form.contractor_data.cpf',
    componentType: 'input',
    columnSize: {
      small: 12,
      medium: 6,
    },
    options: {
      mask: '999.999.999-99',
    },
    validations: {
      primitiveType: 'string',
      required: true,
      min: 11,
      isCpf: true,
    },
  },
]
